import React, { useState } from 'react'
import { track } from "../../../../analytics";
import './HomeServicesCard.scss'
import ConnectModal from '../../../General/Components/ConnectModal/ConnectModal'

// В данных строки списка кончаются на «;» или «.» — это хвост старой
// вёрстки отдельными абзацами. Данные не трогаем, срезаем при выводе:
// пункты списка знаками препинания не разделяют.
const itemText = (s) => (s || '').trim().replace(/[;.]+$/, '')

const HomeServicesCard = ({ img, title, subTitle, textBtn }) => {
  const [modalOpen, setModalOpen] = useState(false)

  return (
    <div className='homeServicesCard_block'>
      <span className="homeServicesCard_icon" aria-hidden="true">{img}</span>
      <h3 className="homeServicesCard_title">{title}</h3>
      <ul className="homeServicesCard_list">
        {subTitle?.map((e, i) => (
          <li key={i}>{itemText(e.item)}</li>
        ))}
      </ul>

      <button
        type="button"
        className="homeServicesCard_btn"
        onClick={() => {
          track("cta_click", { place: "home_service", label: title || "" });
          setModalOpen(true);
        }}
      >
        Подключить
      </button>

      <ConnectModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        serviceName={title}
        apiEndpoint="/add_deal_ckc"
        useServiceName={true}
      />
    </div>
  )
}

export default HomeServicesCard
